<template>
  <v-layout row>
      <v-flex xs2>
        {{label}}
      </v-flex>
      <v-flex xs10>
          <span style="font-weight:bold">{{info}}</span>
      </v-flex>
    </v-layout>
</template>

<script>
export default {
  props: ['label', 'info']
}
</script>

<style>

</style>
